import { lazy } from "react";
import PasswordContextProvider from "../contexts/PasswordContext";

const masterlistConfig = [
  {
    path: "users",
    component: lazy(() => import("../routes/masterlist/UserAccounts/")),
    wrapper: PasswordContextProvider,
  },
  {
    path: "new-user",
    component: lazy(() => import("../routes/masterlist/UserAccounts/NewUser")),
  },
  {
    path: "update-user/:id",
    component: lazy(() => import("../routes/masterlist/UserAccounts/UpdateUser")),
  },
  {
    path: "organization-departments",
    component: lazy(() => import("../routes/masterlist/Organization/Organization")),
  },
  { path: "categories", component: lazy(() => import("../routes/masterlist/Categories")) },
  {
    path: "document-types",
    component: lazy(() => import("../routes/masterlist/DocumentTypes")),
  },
  {
    path: "book-of-accounts",
    component: lazy(() => import("../routes/masterlist/BookOfAccounts/BOA")),
  },
  { path: "voucher-codes", component: lazy(() => import("../routes/masterlist/VoucherCodes")) },
  { path: "one-charging", component: lazy(() => import("../routes/masterlist/OneCharging")) },
  { path: "companies", component: lazy(() => import("../routes/masterlist/Companies")) },
  { path: "business-unit", component: lazy(() => import("../routes/masterlist/BusinessUnits")) },
  { path: "departments", component: lazy(() => import("../routes/masterlist/Departments")) },
  {
    path: "department-units",
    component: lazy(() => import("../routes/masterlist/DepartmentUnits")),
  },
  { path: "sub-unit", component: lazy(() => import("../routes/masterlist/SubUnits")) },
  { path: "locations", component: lazy(() => import("../routes/masterlist/Locations")) },
  { path: "references", component: lazy(() => import("../routes/masterlist/References")) },
  {
    path: "supplier-types",
    component: lazy(() => import("../routes/masterlist/SupplierTypes")),
  },
  { path: "suppliers", component: lazy(() => import("../routes/masterlist/Suppliers")) },
  {
    path: "utility-categories",
    component: lazy(() => import("../routes/masterlist/UtilityCategories")),
  },
  {
    path: "utility-locations",
    component: lazy(() => import("../routes/masterlist/UtilityLocations")),
  },
  {
    path: "account-numbers",
    component: lazy(() => import("../routes/masterlist/AccountNumbers/")),
  },
  { path: "credit-cards", component: lazy(() => import("../routes/masterlist/CreditCards")) },
  {
    path: "account-types",
    component: lazy(() => import("../routes/masterlist/GreatGrandParents")),
  },
  { path: "account-groups", component: lazy(() => import("../routes/masterlist/GrandParents")) },
  { path: "account-subgroups", component: lazy(() => import("../routes/masterlist/Parents")) },
  {
    path: "financial-statements",
    component: lazy(() => import("../routes/masterlist/Children")),
  },
  {
    path: "normal-balances",
    component: lazy(() => import("../routes/masterlist/PL Categories")),
  },
  { path: "units", component: lazy(() => import("../routes/masterlist/Units")) },
  {
    path: "account-titles",
    component: lazy(() => import("../routes/masterlist/AccountTitles")),
  },
  {
    path: "payroll-clients",
    component: lazy(() => import("../routes/masterlist/PayrollClients")),
  },
  {
    path: "payroll-categories",
    component: lazy(() => import("../routes/masterlist/PayrollCategories")),
  },
  { path: "banks", component: lazy(() => import("../routes/masterlist/Banks")) },
  {
    path: "bank-series",
    component: lazy(() => import("../routes/masterlist/Bank Series/BankSeries")),
  },
  { path: "reasons", component: lazy(() => import("../routes/masterlist/Reasons")) },
  {
    path: "treasuries",
    component: lazy(() => import("../routes/masterlist/Treasuries/Treasuries")),
  },
  {
    path: "debit-requestors",
    component: lazy(() => import("../routes/masterlist/DebitRequestors")),
  },
  {
    path: "general-journal-approvers",
    component: lazy(() => import("../routes/masterlist/GeneralJournalApprovers")),
  },
];

export default masterlistConfig;
